$(document).ready(() => {
//    $('.MJ__setFrame2').hide();
   $('.frameActive').show();
})


window.addEventListener("load", function () {
    if ($('#nth-ms-event-detail').length > 0 || $('#nth-ms-event-list').length > 0) {
        return;
    }
    if ($('body').data('device-type') === 'mobile') {
        document.addEventListener('touchmove', function(e) {
            e.preventDefault();
          }, { passive: false });
    }
    let flagScroll = false;
    

    $('.fakeClick , .fakeClick-mb').on('click', function () {
        if ($(this).hasClass('active')) return;
        if (flagScroll) return;

        $('.detail-menu').removeClass('active');
 
        // loadSwiper();

        // Reset scroll position to the top
        $('.MJ__setFrame2').eq($(this).index()).addClass('MJ__readyFrame').show();


        // Tránh lặp lại sự kiện cuộn chuột
        flagScroll = true;
        $('.frameActive').animate({
            opacity: 0
        }, 400, () => {
            $('.frameActive').removeClass('frameActive').css('opacity', 1).show();
            $('.MJ__readyFrame').addClass('frameActive').removeClass('MJ__readyFrame');
            flagScroll = false;

            $('html').scrollTop(0);
        });

        // ss
        $('.fakeClick, .fakeClick-mb').removeClass('active');
        $(this).addClass('active');

      
        if ($(this).index() === 4) {
            $('#nth-ms-footer').css('z-index', '10');
            $('#nth-ms-footer').css('opacity', '1');
           
            if ($('body').data('device-type') === 'desktop') {
                $('html').addClass('fix-mobile');
            } else {
           
                
             
                $('#nth-ms-footer').css('bottom',Math.abs($('#nth-ms-socials')[0].getBoundingClientRect().height - window.innerHeight)  + $('#vxphl-ld-25-a-navigation')[0].getBoundingClientRect().height + 'px');
            }
        } else {
            $('#nth-ms-footer').css('z-index', '1');
            $('#nth-ms-footer').css('opacity', '0');
            if ($('body').data('device-type') === 'desktop') {
                $('html').removeClass('fix-mobile');
            }
        
            
           
        }
       
       


    })

    function ClickEffect(e) {
        if (!e.clientX || !e.clientY)
            return;


        let i = $('\n      <svg id="zDJFK__00_20__png_hecheng_21" class="zDJFK__00_20__png_hecheng_21" viewBox="0,0,270,270">\n<foreignObject width="270" height="270">\n<div id="zDJFK__00_20__png_hecheng_21-under-svg" class="zDJFK__00_20__png_hecheng_21-under-svg">placeholder</div>\n</foreignObject>\n</svg>');
        i.css({
            left: e.clientX,
            top: e.clientY
        }),
            i.find("#zDJFK__00_20__png_hecheng_21-under-svg").on("animationend", (() => {
                i.off("animationend"),
                    i.remove(),
                    i = null
            }
            )),
            $(".click-anim-cnt").append(i)

    };
    if ($('body').data('device-type') === 'mobile') {
        $("body").click((e => {
            if ($(e.target).closest('a').length === 0) {
                ClickEffect(e);
            }
           

        }));
    
        
    }
   

});


$(document).on('wheel', function (event) {
    const $frames = $('.fakeClick');
    const currentIndex = $('.frameActive').index();

    if (event.originalEvent.deltaY > 0) {
        // Cuộn xuống
        if (currentIndex >= $frames.length - 1) return; // Đã tới cuối → thoát
        $frames.eq(currentIndex + 1).trigger('click');
    } else {
        // Cuộn lên
        if (currentIndex <= 0) return; // Đã ở đầu → thoát
        $frames.eq(currentIndex - 1).trigger('click');
    }
});

let touchStartY = 0;
let touchEndY = 0;
let touchStartX = 0;
let touchEndX = 0;

$(document).on('touchstart', function (e) {
    const touch = e.originalEvent.touches[0];
    touchStartY = touch.clientY;
    touchStartX = touch.clientX;
});

$(document).on('touchend', function (e) {
    if ($('.popup-box').hasClass('active')) return;

    const touch = e.originalEvent.changedTouches[0];
    touchEndY = touch.clientY;
    touchEndX = touch.clientX;

    const deltaY = touchEndY - touchStartY;
    const deltaX = touchEndX - touchStartX;

    // Nếu vuốt dọc nhiều hơn vuốt ngang → xử lý
    if (Math.abs(deltaY) > Math.abs(deltaX)) {
        const $frames = $('.fakeClick-mb');
        const currentIndex = $('.frameActive').index();

        if (deltaY < 100) {
            // Vuốt lên
            if (currentIndex >= $frames.length - 1) return; // Đã ở cuối
            $frames.eq(currentIndex + 1).trigger('click');
        } else if (deltaY > 100) {
            // Vuốt xuống
            if (currentIndex <= 0) return; // Đã ở đầu
            $frames.eq(currentIndex - 1).trigger('click');
        }
    }
});